import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { Box, Divider, Typography } from '@mui/material';
import StorageIcon from '@mui/icons-material/Storage';

const BG_SECTION     = '#1c1c24';
const BG_CARD        = '#24242e';
const BRAND_RED      = '#c0392b';
const TEXT_PRIMARY   = '#f4f4f6';
const TEXT_SECONDARY = 'rgba(244,244,246,0.65)';
const BORDER_SUBTLE  = '1px solid rgba(255,255,255,0.08)';

function BillingRow({ label, value }: { label: string; value: React.ReactNode }) {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.25 }}>
            <Typography variant='body2' color={TEXT_SECONDARY}>{label}</Typography>
            <Typography variant='body2' fontWeight={600} color={TEXT_PRIMARY}>{value}</Typography>
        </Box>
    );
}

export default function BillingInfoForm() {
    const billing = useSelector((state: RootState) => state.sessionUserConfig.billing);

    return (
        <Box sx={{ bgcolor: BG_SECTION, borderRadius: '10px', border: BORDER_SUBTLE, p: { xs: 2, sm: 3 } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: { xs: 2, sm: 3 } }}>
                <StorageIcon sx={{ color: TEXT_SECONDARY }} />
                <Typography variant='h6' fontWeight={600} color={TEXT_PRIMARY}>Billing</Typography>
            </Box>

            <Box sx={{ bgcolor: BG_CARD, borderRadius: '8px', px: 2, border: BORDER_SUBTLE }}>
                <BillingRow label='Contents Storage' value={`${billing?.contentsStorage ?? 0} MB`} />
                <Divider sx={{ borderColor: 'rgba(255,255,255,0.05)' }} />
                <BillingRow label='Projects Storage' value={`${billing?.projectsStorage ?? 0} MB`} />
                <Divider sx={{ borderColor: 'rgba(255,255,255,0.05)' }} />
                <BillingRow label='Total Storage' value={`${billing?.megabytes ?? 0} MB`} />
                <Divider sx={{ borderColor: 'rgba(255,255,255,0.05)' }} />
                <BillingRow label='Per Megabyte' value={`$${billing?.perUnit ?? 0}`} />
                <Divider sx={{ borderColor: 'rgba(255,255,255,0.05)' }} />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5 }}>
                    <Typography variant='body2' fontWeight={700} color={TEXT_PRIMARY}>Total</Typography>
                    <Typography variant='body1' fontWeight={700} color={BRAND_RED}>${billing?.perUnit ?? 0}</Typography>
                </Box>
            </Box>
        </Box>
    );
}
